export const WINDOW_SIZE_CHANGED_START = 'WINDOW_SIZE_CHANGED_START';
export const WINDOW_SIZE_CHANGED_FINISH = 'WINDOW_SIZE_CHANGED_FINISH';

export const windowSizeChanged = ({
	                                  windowSizeIsTiny,
	                                  windowSizeIsSmall,
	                                  windowSizeIsMedium,
	                                  windowSizeIsLarge,
	                                  windowSizeIsShort,
                                  }, forceUpdate = false) => (dispatch, getState) => {
	const state = getState();
	const { windowSize: windowState, settings } = state;

	const update = {
		windowSizeIsTiny,
		windowSizeIsSmall,
		windowSizeIsMedium,
		windowSizeIsLarge,
		windowSizeIsShort
	};
	let isSame = true;
	_.each(update, (value, key) => {
		if(value !== windowState[key]) {
			isSame = false;
			return false;
		}
	});
	if(isSame && !forceUpdate) {
		return;
	}

	if(windowState.windowSizeIsMedium && !update.windowSizeIsMedium) {
		const currentTab = getState().matchmaking.selectedTab;
		if(currentTab === 'chat') {
			// dispatch({
			// 	type: CHANGE_MATCHMAKING_TAB
			// });
		}
	}

	dispatch({
		type: WINDOW_SIZE_CHANGED_START,
		payload: update
	});
	dispatch({
		type: WINDOW_SIZE_CHANGED_FINISH,
		payload: {
			...update,
			settings,
		}
	});
};